import _ from "lodash";

// Working Hours Configuration
export const WEEK_DAYS = [
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
  { label: "Sunday", value: "sunday" }
];

export const DEFAULT_DAY_HOURS = {
  start: "09:00",
  end: "17:00"
};

export const addBranchLookup = (state, action) => {
  let list = state.list;
  const savedBranchLookup = action.payload;

  return [savedBranchLookup, ...list];
};

export const updateBranchLookup = (state, action) => {
  let list = state.list;
  const updatedBranchLookup = action.payload;

  const index = _.findIndex(list, ["id", updatedBranchLookup.id]);
  list[index] = updatedBranchLookup;

  return [...list];
};

export const removeBranchLookup = (state, action) => {
  let list = state.list;
  const deletedBranchLookup = action.payload;

  const filteredList = _.filter(list, function (td) {
    return td.id !== deletedBranchLookup.id;
  });

  return [...filteredList];
};
export const formtValidationErrors = (validationErrors) => {
  const keys = Object.keys(validationErrors);
  const errors = [];

  keys.forEach((key) => {
    errors.push({
      name: key,
      errors: validationErrors[key],
    });
  });

  return errors;
};

export const parseWorkingHours = (workingDaysData, defaultValue) => {
  if (!workingDaysData) {
    return defaultValue;
  }

  try {
    return typeof workingDaysData === 'string' 
      ? JSON.parse(workingDaysData) 
      : workingDaysData;
  } catch (e) {
    console.error("Error parsing working hours:", e);
    return defaultValue;
  }
};

export const formatWorkingHoursForSave = (dayHours, timezone) => {
  return JSON.stringify({
    timezone: timezone || "Africa/Addis_Ababa",
    ...dayHours,
    exceptions: {}
  });
};

export const formatDayHoursToWorkingHours = (dayHours, WEEK_DAYS) => {
  const workingHoursData = {};
  WEEK_DAYS.forEach(day => {
    const dayData = dayHours[day.value];
    if (dayData.enabled) {
      workingHoursData[day.value] = {
        start: dayData.start,
        end: dayData.end
      };
    } else {
      workingHoursData[day.value] = null;
    }
  });
  return workingHoursData;
};

export const validateWorkingHours = (dayHours) => {
  return Object.values(dayHours).some(day => day.enabled);
};

export const initializeDayHours = (existingWorkingHours, WEEK_DAYS, DEFAULT_DAY_HOURS) => {
  const dayHours = {};
  const weekdayDefaults = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
  
  WEEK_DAYS.forEach(day => {
    const dayData = existingWorkingHours?.[day.value];
    const hasExistingData = dayData !== null && dayData !== undefined;
    
    dayHours[day.value] = {
      enabled: hasExistingData ? (dayData !== null) : weekdayDefaults.includes(day.value),
      start: dayData?.start || DEFAULT_DAY_HOURS.start,
      end: dayData?.end || DEFAULT_DAY_HOURS.end
    };
  });
  return dayHours;
};
